module.exports = __webpack_public_path__ + "static/media/arrow_small_right_black.271a31a8.svg";